export type UnknownPath = string

const UNKNOWN_KEY = '$unknown'
const DEGRADED_KEY = '$degraded'

export function attachUnknown(
  entity: object,
  paths: readonly UnknownPath[],
  degraded: boolean
): void {
  Object.defineProperty(entity, UNKNOWN_KEY, {
    value: Object.freeze([...paths]),
    enumerable: false,
    writable: false,
    configurable: true,
  })
  Object.defineProperty(entity, DEGRADED_KEY, {
    value: degraded,
    enumerable: false,
    writable: false,
    configurable: true,
  })
}

export function getUnknown(entity: object): readonly UnknownPath[] {
  const descriptor = Object.getOwnPropertyDescriptor(entity, UNKNOWN_KEY)
  if (!descriptor || !Array.isArray(descriptor.value)) {
    return []
  }

  return descriptor.value as readonly UnknownPath[]
}

export function isDegraded(entity: object): boolean {
  const descriptor = Object.getOwnPropertyDescriptor(entity, DEGRADED_KEY)
  return descriptor?.value === true
}
